"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPropDefinitions = exports.Prop = void 0;
var Observable_1 = require("./Observable");
var formatting_1 = require("../../utils/formatting");
var METADATA_KEY = '_salvo_props';
function Prop() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    /* eslint-enable @typescript-eslint/naming-convention, max-len */
    // Default options
    var options = {};
    // Implementation
    function decorator(target, name) {
        return propImplementation(target, name, options);
    }
    // Factory - use as @Observable({..})
    if (args.length < 2) {
        var arg = args[0];
        if (typeof arg == 'string') {
            options = {
                attr: arg
            };
        }
        else {
            options = arg;
        }
        return decorator;
    }
    // Direct - use as @Observable
    var _a = __read(args, 2), target = _a[0], name = _a[1];
    return decorator(target, name);
}
exports.Prop = Prop;
// Implementation
function propImplementation(prototypeTarget, propertyKey, options) {
    // Proprety type
    var propertyType = Reflect.getMetadata('design:type', prototypeTarget, propertyKey);
    var propertyTypeName = propertyType.name;
    var simpleTypes = [
        'String', 'Number', 'Date', 'Function',
    ];
    var isSimpleType = simpleTypes.indexOf(propertyTypeName) > -1
        && typeof propertyType == 'function';
    // Options
    if (typeof options == 'string') {
        options = {
            attr: options
        };
    }
    var fullOptions = __assign({ attr: (0, formatting_1.kebabCase)(propertyKey.toString()), default: undefined, reflectAttr: isSimpleType }, options);
    // Propery definition
    var propDef = __assign(__assign({}, fullOptions), { propertyKey: propertyKey, propertyType: propertyType, propertyTypeName: propertyTypeName });
    // Store definition in reflection metadata
    // eslint-disable-next-line @typescript-eslint/no-misused-new
    var prototypeTargetActual = prototypeTarget;
    var list = Reflect.getMetadata(METADATA_KEY, prototypeTargetActual.constructor) || [];
    list.push(propDef);
    Reflect.defineMetadata(METADATA_KEY, list, prototypeTargetActual.constructor);
    // Replace property with observable version
    (0, Observable_1.makePropertyObservable)(prototypeTarget, propertyKey);
    (0, Observable_1.registerHandler)(prototypeTarget, propertyKey, function (value) {
        // Notify component when prop changes
        this.$onPropUpdated(propDef, value);
    });
}
/** @internal */
function extractPropDefinitions(targetCtor) {
    return Reflect.getMetadata(METADATA_KEY, targetCtor) || [];
}
exports.extractPropDefinitions = extractPropDefinitions;
//# sourceMappingURL=Prop.js.map